import React from 'react';
import PropTypes from 'prop-types';
import { QRCodeSVG } from 'qrcode.react';

import SmartImage from 'dpl/components/SmartImage';
import { BUYER_APP_STORE_URL } from 'dpl/shared/constants/urls';
import { isMobileSafari } from 'dpl/shared/utils';

import appStoreAppleDark from 'dpl/assets/app_store-apple-dark.png';
import appStoreAndroidDark from 'dpl/assets/homepage/google_play_dark.png';
import appDesktopImg from 'dpl/assets/homepage/app_desktop.jpeg';
import appMessengerImg from 'dpl/assets/homepage/app_messenger.png';
import appMobileImg from 'dpl/assets/homepage/app_mobile.png';

/** @param {any} props */
export function SectionContent({ className = '' }) {
  return (
    <div className={className}>
      <h4 className="font-32 md:font-40 lh-title mb4">
        The all-in-one app for bringing home your best friend.
      </h4>
      <p className="font-16 md:font-18">
        Connect with ethical sources, get updates, and pay securely—all in one
        trusted app.
      </p>
      <div className="hidden md:block">
        <p className="font-18 fw-medium mt14 mb4">
          Scan the QR code to get the app.
        </p>
        <div className="flex ba max-content b--white bw1">
          <QRCodeSVG value={BUYER_APP_STORE_URL} size={80} fgColor="#283E52" />
        </div>
      </div>
      <div className="md:hidden mt4">
        <a href={BUYER_APP_STORE_URL} className="flex">
          {isMobileSafari ? (
            <img
              src={appStoreAppleDark}
              alt="Apple App Store badge"
              width="134px"
            />
          ) : (
            <img
              src={appStoreAndroidDark}
              alt="Android Play Store badge"
              width="134px"
            />
          )}
        </a>
      </div>
    </div>
  );
}

SectionContent.propTypes = {
  className: PropTypes.string
};

export default function MobileAppQRSection() {
  return (
    <section className="MobileAppQRSection bg-stone-700 section-fade">
      {/* mobile */}
      <div className="md:hidden">
        <div className="container-xl flex justify-center">
          <SmartImage src={appMobileImg} />
        </div>
        <SectionContent className="container-xl bg-sand pb12 pt6" />
      </div>

      {/* desktop */}
      <div className="container-xl hidden md:grid md:grid-cols-4">
        <div className="MobileAppQRSection__column-1">
          <SectionContent className="w-90-md w-70-lg white" />
        </div>
        <SmartImage
          wrapperOnlyClassName="MobileAppQRSection__column-2 md:hidden lg:block"
          src={appMessengerImg}
          height="466px"
        />
        <div className="MobileAppQRSection__column-3">
          <SmartImage
            Tag="div"
            src={appDesktopImg}
            className="w-100 h-100 bg-center cover"
          />
        </div>
      </div>
    </section>
  );
}
